import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
    settings: {
        email: '',
        phone: ''
    },
    admobSettings: {
        admob_enabled: false,
        admob_user_targeting: '',
        target_options: {}
    },
    loading: false,
    error: null,
};

export const fetchSupportEmail = createAsyncThunk(
    'settings/fetchSupportEmail',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get('/api/admin/settings/support-email');
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch settings');
        }
    }
);

export const updateSupportEmail = createAsyncThunk(
    'settings/updateSupportEmail',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/api/admin/settings/support-email', data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to update settings');
        }
    }
);

export const getGoogleAdmob = createAsyncThunk(
    'settings/getGoogleAdmob',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get('/api/admin/settings/google-admob', data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to update settings');
        }
    }
);

export const updateGoogleAdmob = createAsyncThunk(
    'settings/updateGoogleAdmob',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/api/admin/settings/google-admob', data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to update settings');
        }
    }
);

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        clearSettingsError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            /* FETCH */
            .addCase(fetchSupportEmail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSupportEmail.fulfilled, (state, action) => {
                state.loading = false;
                state.settings = action.payload;
            })
            .addCase(fetchSupportEmail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            /* UPDATE */
            .addCase(updateSupportEmail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateSupportEmail.fulfilled, (state, action) => {
                state.loading = false;
            })           
            .addCase(updateSupportEmail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getGoogleAdmob.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.loading = false;
                state.admobSettings = data;
            })
            .addCase(updateGoogleAdmob.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.loading = false;
                state.admobSettings = data;
            });
    },
});

export const { clearSettingsError } = settingsSlice.actions;
export default settingsSlice.reducer;
